module.exports = __webpack_public_path__ + "img/developer.aefb9fc7.svg";